import 'core-js/es6/map';
import 'core-js/es6/set';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import { createStore } from 'redux';
import { ThumbReducer } from './store/action';
import { Provider } from 'react-redux';
// import './index.css';
// import registerServiceWorker from './registerServiceWorker';
const store = createStore(ThumbReducer)

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root') as HTMLElement
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx